export default {
  translations: {
    login: {
      welcomeTitle: 'Bienvenido',
      importantMessage: 'Todas las conversaciones de chat serán grabadas y podrán ser auditadas por MJV.',
      description: 'Por favor, inicie sesión con su cuenta corporativa.',
      loginLabel: 'Usuario',
      loginPlaceholder: 'Ingrese su nombre.apellido',
      loginPattern: 'Su [Usuario] debe tener entre 3 y 260 caracteres',
      passwordLabel: 'Contraseña',
      passwordPlaceholder: 'Ingrese su contraseña',
      passwordPattern: 'Su [Contraseña] debe tener entre 5 y 300 caracteres',
      buttonMessageOk: 'ACCESO',
      buttonMessageWait: 'ESPERA...',
    },
    home: {
      textBreadcrumb: '¡Comenzando con Iron!',
      welcomeMessage: 'Bienvenido a IRON',
      description: 'Chatea con uno de nuestros agentes y desata lo mejor de ti en términos de capacidad y creatividad.',
      callToAction: 'Prueba uno de nuestros agentes',
      agentAll: 'General',
      descriptionAgentAll: 'Obtén respuestas a tus preguntas sobre una variedad de temas, sin necesidad de un enfoque específico.',
      agentHistoryUser: 'Historias de Usuario',
      descriptionAgentHistoryUser: 'Usa tu especialista en historias de usuario para tu proyecto.',
      agentPointFunction: 'Puntos de Función',
      descriptionAgentPointFunction: 'Experto en calcular puntos de función para tu proyecto.',
      agentBackLog: 'Backlog',
      descriptionAgentBackLog: 'Experto en la creación de backlogs para tu proyecto.',
      agentDev: 'Desarrollo',
      descriptionAgentDev: 'Experto en desarrollar nuevas funciones y mantener tu sistema.',
      agentCasesOfTests: 'Casos de Pruebas',
      descriptionAgentCasesOfTests: 'Experto en crear escenarios de prueba para tu proyecto.',
      agentQA: 'QA',
      descriptionAgentQA: 'Experto en aseguramiento de calidad y pruebas automatizadas de software.',
      agentVulnerabilities: 'Vulnerabilidades',
      descriptionAgentVulnerabilities: 'Experto en corregir vulnerabilidades en tu sistema.',
      agentFortify: 'Fortify',
      descriptionAgentFortify: 'Experto en corregir vulnerabilidades identificadas por Fortify.',
      agentSupport: 'Soporte',
      descriptionAgentSupport: 'Experto en brindar soporte para tu proyecto.',
      agentSaude: 'Bradesco Salud',
      descriptionAgentSaude: 'Experto en preguntas y respuestas sobre la aplicación Bradesco Salud.',
      buttonChat: 'Chat',
      agentQualys: 'Qualys',
      descriptionAgentQualys: 'Experto en corregir vulnerabilidades identificadas por Qualys.',
    },
    menu: {
      iasSection: 'Agentes',
      iaSwagger: 'Swagger',
      iaGeral: 'General',
      iaUserHistory: 'Historias de Usuario',
      iaPointFunction: 'Puntos de Función',
      iaBacklog: 'Backlog',
      iaDev: 'Desarrollo',
      iaTestCase: 'Casos de Pruebas',
      iaQA: 'Scripts de Pruebas',
      iaVulnerabilities: 'Vulnerabilidades',
      iaFortify: 'Fortify',
      iaSupport: 'Soporte',
      iaSupportAbs: 'Bradesco Salud',
      historySection: 'Historial',
      historyMessageSelect: 'Seleccione un Agente.',
      historyNull: 'No hay historial disponible.',
      dashboardSection: 'Panel de Uso',
      panelAdminSection: 'Panel Administrativo',
      panelConfigSection: 'Configuraciones',
      logout: 'Cerrar sesión',
      iaAccessibility: 'Accesibilidad',
      iaQualys: 'Qualys',
    },
    chatsBreadcrumbs: {
      iaTitle: 'Agentes Artificiales',
      iaGeral: 'General',
      iaUserHistory: 'Historias de Usuario',
      iaPointFunction: 'Puntos de Función',
      iaSwagger: 'Swagger',
      iaBacklog: 'Backlog',
      iaDev: 'Desarrollo (Dev)',
      iaTestCase: 'Casos de Pruebas',
      iaQa: 'QA',
      iaVulnerability: 'Vulnerabilidades',
      iaFortify: 'Fortify',
      iaSupport: 'Soporte',
      iaAccessibility: 'Accesibilidad',
      iaSupportAbs: 'Soporte Bradesco Salud',
      iaQualys: 'Qualys',
      iaFunctionPoint: 'Puntos de Función',
      iaSwagger: 'Swagger',

      details: 'Detalles',
    },
    chatWelcomeBlock: {
      title: '¿Cómo puedo ayudarte?'
    },
    chatForms: {
      textAreaPlaceholder: 'Escribe un mensaje a Iron',
      selectDefault: 'Selecciona...',
      continueButton: 'Continuar generación'
    },
    chatThinking: {
      messages: [
        'Pensando...',
        'Analizando tu pregunta...',
        'Consultando la base de conocimiento...',
        'Preparando la mejor respuesta...',
        'Conectando las ideas...',
        'Casi allí...'
      ]
    },
    iaDevModal: {
      title: 'Agrega tu código aquí:',
      fileLabel: 'Subir archivo de código',
      filePlaceholder: 'Haz clic o arrastra un archivo aquí',
      fileSupport: 'Soporta archivos .js, .py, .java, etc.',
      languageLabel: 'Selecciona el lenguaje del archivo',
      languageUndefined: 'Lenguaje indefinido',
      languageUndefinedMessage: 'Lenguaje indefinido, algunas funciones pueden no funcionar como se espera.',
      buttonSend: 'Enviar',
      buttonCancel: 'Cancelar',
    },
    overlayQA: {
      titleOverlay: 'Configuraciones del Agente',
      description: 'Selecciona las opciones a continuación para obtener una respuesta más precisa de nuestros agentes.',
      title1: '¿Qué tipo de prueba quieres realizar?',
      description1: 'Elige el tipo de prueba que deseas realizar. Las opciones pueden incluir pruebas manuales y automatizadas.',
      ariaLabel1: 'Selecciona el tipo de prueba',
      title2: '¿Qué nivel de prueba deseas realizar?',
      description2: 'Define el nivel de la prueba que deseas aplicar, que puede variar entre pruebas unitarias, de integración y end-to-end.',
      ariaLabel2: 'Selecciona el nivel de la prueba',
      title3: '¿Qué framework se aplicará?',
      description3: 'Elige el framework que usarás para realizar la prueba. Las opciones pueden incluir Cucumber, Cypress, Selenium, etc.',
      ariaLabel3: 'Selecciona el framework',
      title4: '¿Qué lenguaje de programación se utiliza?',
      description4: 'Selecciona el lenguaje de programación que estás utilizando para las pruebas. Las opciones pueden incluir Java, Python, JS, etc.',
      ariaLabel4: 'Selecciona el lenguaje de programación',
      buttonSave: 'Guardar configuraciones',
      manual: 'Pruebas Manuales',
      automated: 'Pruebas Automatizadas',
      endToEnd: 'End-to-End',
      integrated: 'Integraciones/Servicios',
      unit: 'Unitario'
    },

    overlaySwagger: {
      titleOverlay: 'Configuraciones del Proyecto',
      description: 'Complete los campos a continuación para crear su proyecto.',
      projectName: 'Nombre del Proyecto',
      projectNameInputText: 'Ingrese el nombre del proyecto',
      projectGroup: 'Grupo',
      projectGroupDescription: 'com.grupo',
      projectPackage: 'Paquete',
      projectPackageDescription: 'com.paquete',
      projectClient: 'Cliente',
      projectType: 'Tipo de Proyecto',
      springBootVersion: 'Versión de Spring Boot',
      developmentLang: 'Lenguaje de Programación',
      javaVersion: 'Versión de Java',
      dependence: 'Dependencias',
      projectDescription: 'Descripción',
      projectDescriptionInput: 'Ingrese la descripción del proyecto',
      swaggerFile: 'Archivo de Swagger',
      saveBtn: 'Guardar',   
    },

    overlayVulnerabilities: {
      titleOverlay: 'Configuraciones del Agente',
      description: 'Selecciona las opciones a continuación para obtener una respuesta más precisa de nuestros agentes.',
      title1: '¿Qué tipo de vulnerabilidad deseas corregir?',
      description1: 'Elige el tipo de error que tu aplicación necesita solucionar.',
      ariaLabel1: 'Selecciona el tipo de error',
      buttonSave: 'Guardar configuraciones',
      none: 'Ninguna',
      critical: 'Crítica',
      high: 'Alta',
      medium: 'Media',
      low: 'Baja'
    },
    iaFortify: {
      detailsVulnerabilities: 'Detalles de la Vulnerabilidad',
      category: 'Categoría',
      nameOfFile: 'Nombre del Archivo',
      numberOfLine: 'Número de Línea',
      path: 'Ruta',
      directory: 'Directorio',
      csvFile: 'Archivo CSV',
      selectDirectory: 'Seleccionar Directorio',
      selectCSV: 'Seleccionar un CSV',
      processSheet: 'Procesar Hoja',
      welcomeMessage: '¡Bienvenido! Por favor selecciona un directorio y un archivo CSV para comenzar.',
      vulnerabilities: 'Vulnerabilidades',
      openWithFortify: 'Abrir con Fortify',
      selected: 'Seleccionado',
      notSelected: 'No seleccionado',
      lineNotSpecified: 'Línea no especificada',
      title: 'Agrega el informe de Fortify aquí:',
      fileLabel: 'Subir informe de Fortify',
      filePlaceholder: 'Haz clic o arrastra un archivo aquí',
      fileSupport: 'Soporta archivos .xml',
      buttonSend: 'Enviar',
      buttonCancel: 'Cancelar',
      syncronized: 'Sincronizado',
      notSyncronized: 'No sincronizado',
      dirSelected: 'Directorio seleccionado',
      dirUnfound: 'Directorio esperado',
      paths: 'Rutas',
      overlayMessage: 'Una vez encontrada la vulnerabilidad, solucione el problema.'
    },
    iaQualys: {
      detailsVulnerabilities: 'Detalles de la Vulnerabilidad',
      openWithQualys: 'Abrir con Qualys',
      selected: 'Seleccionado',
      notSelected: 'No seleccionado',
      welcomeMessage: '¡Bienvenido! Por favor selecciona un archivo CSV para comenzar.',
      selectCSV: 'Seleccionar un CSV',
      processSheet: 'Procesar Hoja',
      csvFile: 'Archivo CSV',
      vulnerabilities: 'Vulnerabilidades',
      ip: 'IP',
      title: 'Título',
      port: 'Puerto',
      action: 'Acción',
      overlayMessage: 'Una vez encontrada la vulnerabilidad, solucione el problema.'
    },
    chatNotFound: {
      mainTitle: '¡Chat no encontrado!',
      title: 'Chat no encontrado 🤖',
      message: 'La página que buscabas no fue encontrada. Haz clic en el botón a continuación para volver a la página principal.',
      buttonMessage: 'Volver a Home'
    },
    dashboardUsage: {
      all: 'Todos',
      tokensSpent: 'Tokens Gastados',
      estimativeValue: 'Valor Estimado',
      spentInTokens: 'Gastado en Tokens',
      spentInTokensDolars: 'Gastado en Tokens (Dólares)',
      interactions: 'Interacciones',
      interactionsByContexts: 'Interacciones por Contextos',
    },
    adminPanel: {
      breadcrumb: 'Panel Administrativo Global',
      title: 'Panel Administrativo 🔒',
      description: 'Crea, modifica y elimina permisos de usuario en la plataforma.',
      buttonCreateUser: 'Crear Usuario',
      username: 'Nombre de Usuario',
      typeUser: 'Rol del Usuario',
      permission: 'Permiso del Usuario',
      actions: 'Acciones',
      newUser: 'Nuevo Usuario',
      close: 'Cerrar',
      usersNotFound: 'No se encontraron usuarios.',
      nameSurname: 'Nombre.Apellido',
      updateUser: 'Actualizar Usuario',
      editUser: 'Editar Usuario',
    },
    profilePanel: {
      breadcrumb: 'Configuraciones del Perfil',
      myData: 'Mis Datos',
      loginLabel: 'Usuario',
      positionLabel: 'Cargo',
      createdAtLabel: 'Fecha de registro',
      trialPeriodLabel: 'Período de Prueba (días)',
      trialPeriodRemainingDaysLabel: 'Días restantes',
      trialRemainingTokensLabel: 'Tokens Restantes',
      spentTokensLabel: 'Tokens Gastados',
      save: 'Guardar Cambios',
      support: 'Soporte',
      descriptionSupport: 'Si tienes alguna pregunta, contacta el soporte de Iron en el siguiente correo electrónico:',
      idioms: "Selecciona un Idioma:",
      ptBr: "Portugués de Brasil (pt-BR)",
      enUs: "Inglés (en-Us)",
      es: "Español (es)",
      cannotChangeYourOwnUser: 'No puedes cambiar los permisos de tu propio usuario.',
      error: 'Error!',
    },
    FortifyFileInputErrors: {
      notSupported: 'Tipo de archivo no soportado! Elija un archivo .csv, .xlsx, .json, .txt, .docx, .doc, .pdf o .feature',
      uploadFile: 'Error al subir el archivo.',
      error: 'Error!',
    },
    downloadDocumentMessage: {
      loading: 'Construyendo documento...',
      success: 'Descargar documento'
    },
    downloadSheetMessage: {
      loading: 'Construyendo hoja...',
      success: 'Descargar Hoja'
    },
    overlayAccessibility: {
      titleOverlay: 'Configuraciones del Agente de Accesibilidad',
      description: 'Especialista en proporcionar accesibilidad a tu proyecto.',
      modalTitleUrlParser: 'Obtener HTML desde una URL',
      modalDescriptionUrlParser: 'Accederé al sitio web solicitado y analizaré su HTML.',
      buttonOpenUrlParser: 'Abrir Extractor de URL',
      modalTitleAccessibility: 'Subir o Pegar Código',
      modalDescriptionAccessibility: 'Puedes subir o pegar tu código para ser analizado.',
      buttonOpenAccessibility: 'Insertar Código HTML',
    },
    accessibilityModalFile: {
      title: 'Subir Código HTML',
      fileLabel: 'Subir el archivo de código para ser analizado',
      fileLabelHint: 'Haz clic o arrastra un archivo aquí para subirlo.',
      sendCode: 'Enviar Código',
      cancelBtn: 'Cancelar',
      characterLimit: "El contenido tiene más de 250,000 caracteres.",
    },
    accessibilityModalUrl: {
      title: 'Analizar URL',
      placeholder: 'Ingrese la URL del sitio web para extraer el HTML',
      analyse: 'Extraer HTML',
      sendCode: 'Enviar Código',
      cancelBtn: 'Cancelar',
      loading: 'Por favor espera...',
      error: 'Intenta nuevamente agregando http:// o https:// al inicio de la URL.',
      characterLimit: "El contenido tiene más de 250,000 caracteres.",
    },
    agents: {
      geral: {
        name: "General",
        description:
          "Soy un Modelo de Lenguaje desarrollado por MJV Technology & Innovation, parte del sistema de IA conocido como Iron. Mi objetivo es ayudar a los empleados de MJV en una amplia gama de temas, proporcionando respuestas informativas y contextualmente relevantes. Estoy aquí para discutir y proporcionar información sobre tecnología, ciencia, arte, conocimiento general y otros asuntos que puedan ser útiles en su vida profesional diaria.",
      },
      historiaDeUsuario: {
        name: "Historia de Usuario",
        description:
          "Soy un agente especialista en análisis de negocios, parte del sistema Iron desarrollado por 'MJV Technology & Innovation'. Estoy aquí para ayudarle en la creación y el detalle de historias de usuario para software web y móvil, siguiendo prácticas Agile, Scrum, Kanban y diseño centrado en el ser humano.",
      },
      pontoDeFuncao: {
        name: "Punto de Función",
        description:
          "Soy un agente especialista en Análisis de Puntos de Función (APF), parte del sistema de IA desarrollado por 'MJV Technology & Innovation'. Mi enfoque es clasificar correctamente las funciones de un sistema como Procesos Elementales (PE) o Datos, siguiendo rigurosamente las reglas y directrices establecidas.",
      },
      backlog: {
        name: "Backlog",
        description:
          "Soy parte de Iron, un sistema de IA desarrollado por 'MJV Technology & Innovation'. Específicamente, soy un agente especialista en transformar historias de desarrollo de software en épicos, historias, tareas y subtareas para crear y estructurar el backlog de proyectos o productos de software. Mi objetivo es asegurar que cada ítem del backlog esté bien definido, claro y ejecutable por el equipo de desarrollo, contribuyendo al éxito del proyecto.",
      },
      dev: {
        name: "Dev",
        description:
          "Soy un agente especialista en desarrollo de software de MJV Technology & Innovation. Estoy aquí para ayudarle a abordar y resolver cuestiones relacionadas con el desarrollo de software, aplicando las mejores prácticas de programación, como separación de responsabilidades, manejo de errores, principios SOLID y otras prácticas recomendadas.",
      },
      casosDeTestes: {
        name: "Casos de Pruebas",
        description:
          "Soy un agente especializado en pruebas de software, parte del sistema de IA Iron desarrollado por MJV Technology & Innovation. Estoy aquí para ayudar en la creación, planificación, ejecución y documentación de casos de prueba detallados para garantizar la calidad y funcionalidad de los sistemas de software.",
      },
      qa: {
        name: "QA",
        description:
          "Soy un agente especialista en QA, parte del sistema de IA desarrollado por MJV Technology & Innovation, enfocado en garantizar la calidad del software. Mi función es ayudar a concebir e implementar estrategias de prueba, especialmente automatizadas, para asegurar que las aplicaciones funcionen como se espera.",
      },
      vulnerabilidade: {
        name: "Vulnerabilidad",
        description:
          "Soy un agente especializado en seguridad de software, parte del sistema de IA conocido como Iron, desarrollado por 'MJV Technology & Innovation'. Mi papel es ayudarle a identificar, corregir y prevenir errores y vulnerabilidades en su software, asegurando que su código sea seguro, robusto y confiable.",
      },
      fortify: {
        name: "Fortify",
        description:
          "Soy un agente especializado en seguridad de software, parte del sistema de IA conocido como Iron, desarrollado por 'MJV Technology & Innovation'. Mi papel es analizar carpetas de código fuente en busca de vulnerabilidades de seguridad, proporcionando información detallada sobre cómo corregirlas y garantizar que su software sea seguro y confiable.",
      },
      support: {
        name: "Soporte",
        description:
          "Soy un agente de inteligencia artificial especializado en Soporte de Sistemas. Mi función principal es ayudar en el análisis y solución de incidentes en sistemas de software, utilizando un historial de incidentes anteriores y las mejores prácticas de soporte técnico.",
      },
      acessibilidade: {
        name: "Accesibilidad",
        description:
          "Soy un agente especializado en accesibilidad de software, parte del sistema de IA conocido como Iron, desarrollado por 'MJV Technology & Innovation'. Mi objetivo es ayudarle a hacer su software accesible para todos los usuarios, incluyendo personas con discapacidades visuales, auditivas, motoras y cognitivas, siguiendo las directrices de accesibilidad web (WCAG).",
      },
      bradescoSaude: {
        name: "Bradesco Saúde",
        description:
          "Soy un agente especialista en sistemas de Preguntas Frecuentes (FAQ) enfocado en la App Bradesco Saúde. Mi objetivo es ayudarle a encontrar respuestas precisas y actualizadas a sus dudas, utilizando una base de conocimiento que soporta varios formatos de archivo como Docx, XLS, XLSX y TXT. Si necesita asistencia relacionada con problemas de acceso, registro, tarjeta de identificación, Idwall, reembolso o token en la App Bradesco Saúde, ¡estoy aquí para ayudar!",
      },
      qualys: {
        name: "Qualys",
        description:
          "Soy un agente especializado en seguridad de red, parte del sistema de IA conocido como Iron, desarrollado por 'MJV Technology & Innovation'. Mi papel es ayudarle a identificar, corregir y prevenir vulnerabilidades en su red, asegurando que sus sistemas y datos estén seguros y protegidos contra amenazas.",
      },
    },
    alerts: {
      updateInProgress: {
        title: "¡Actualización en Progreso!",
        message:
          "Iron está pasando por actualizaciones y puede estar temporalmente fuera de servicio. ¡Gracias por su comprensión!",
      },
    },
    common: {
      close: "Cerrar",
    },
    history: {
      title: "Historial de Conversación",
      description: "Accede al historial de conversaciones realizadas con uno de nuestros agentes.",
      searchForName: "Buscar por título:",
      searchForNamePlaceholder: "Introduce el título...",
      searchFor: "Filtrar por:",
      allAgents: "Todos los agentes",
      tableAgent: "Agente",
      tableTitle: "Título",
      tableDate: "Fecha",
      tableAction: "Acciones",
      reopenChat: "Reabrir Chat",
      edit: "Editar",
      remove: "Eliminar",
      chatNameGeral: "General",
      chatNameUserHistory: "Historia de Usuario",
      chatNameBacklog: "Backlog",
      chatNameDev: "Desarrollo",
      chatNameTestCase: "Casos de Pruebas",
      chatNameQA: "QA",
      chatNameSwagger: "Swagger",
      chatNameVulnerability: "Vulnerabilidades",
      chatNameFortify: "Fortify",
      chatNameAccessibility: "Accesibilidad",
      chatNameSupportAbs: "Bradesco Saúde",
      chatNameSupport: "Soporte",
      chatNameFunctionPoint: "Puntos de Función",
      backendGetDataError: "Error al obtener datos del backend:",
      erroToLoadData: "Error al cargar datos",
      editHistoryModalTitle: "Editar título del historial",
      editHistoryModalInputPlaceholder: "Introduce el nuevo nombre",
      editHistoryModalSave: "Guardar",
      editHistoryModalCancel: "Cancelar",
      editHistoryModalSucess: "¡Título actualizado con éxito!",
      editHistoryErroToUpdateTitle: "Error al actualizar el título:",
      editHistoryErroToUpdateAgentName: "Error al actualizar el nombre del agente.",
      removeHistoryTitle: "¿Estás seguro?",
      removeHistoryAlert: "¡No podrás revertir esto!",
      removeHistoryConfirm: "Sí, eliminar",
      removeHistoryCancel: "Cancelar",
      removeHistoryError: "Error al eliminar el agente:",
      removeHistorySuccess: "¡Eliminado con éxito!",
      noDataMessage: "No hay datos para mostrar",
    },
    maintenanceAlert: {
      "title": "Aviso de mantenimiento programado",
      "greeting": "Estimado usuario",
      "message": "Le informamos que la plataforma MJV Iron no estará disponible temporalmente para una actualización del sistema. La interrupción se producirá a partir del 05/11, con un regreso programado para el 06/11.",
      "importance": "Esta actualización es esencial para mejorar la seguridad y el rendimiento de la plataforma, ofreciéndote una experiencia aún mejor.",
      "request": "Le solicitamos que organice sus actividades para evitar impactos durante este período.",
      "thankYou": "Le agradecemos su comprensión y estamos disponibles para cualquier pregunta."
    },
  }
}
